import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import {
    CardContainer,
    ImageContainer,
    Content,
    CareerPathHeader,
    Header,
    OuterArrowContainer,
    ArrowContainer,
    UpskillWithAIWhiteArrow,
    UpskillWithAIBlueArrow,
    UpskillWithAIPinkArrow
} from "./build-with-ai-cta.styles"

export const UpskillCard = ({
    image,
    bgColor,
    careerPathHeader,
    header,
    textColor = 'white',
    headerColor = 'white',
    defaultArrow = 'white',
    hoverArrow = 'blue',
    arrowBgColor = 'transparent',
    arrowBgHoverColor = 'white',
    arrowBorderColor = 'white',
    arrowBorderHoverColor = 'white',
    ...props
}) => {
    return (
        <CardContainer 
            $bgColor={bgColor}
            $defaultArrow={defaultArrow}
            $hoverArrow={hoverArrow}
            $arrowBgHoverColor={arrowBgHoverColor}
            $arrowBorderHoverColor={arrowBorderHoverColor}
            {...props}
            firstChild={true}
        >
            <ImageContainer>
                <GatsbyImage image={image} alt={header} />
            </ImageContainer>
            <Content>
                <CareerPathHeader $textColor={textColor}>
                    {careerPathHeader}
                </CareerPathHeader>
                <Header $headerColor={headerColor}>
                    {header}
                </Header>
            </Content>
            <OuterArrowContainer>
                <ArrowContainer 
                    $defaultArrow={defaultArrow}
                    $arrowBgColor={arrowBgColor}
                    $arrowBorderColor={arrowBorderColor}
                >
                    <UpskillWithAIWhiteArrow tabIndex={0} />
                    <UpskillWithAIBlueArrow tabIndex={0} />
                    <UpskillWithAIPinkArrow tabIndex={0} />
                </ArrowContainer>
            </OuterArrowContainer>
        </CardContainer>
    );
};